export default __webpack_public_path__ + "static/media/down-arrow.d0d845f9.svg";